import { render, staticRenderFns } from "./ProductIconsCarousel.vue?vue&type=template&id=dfe1b436&scoped=true&"
import script from "./ProductIconsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductIconsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe1b436",
  null
  
)

export default component.exports